import { OnlyFansVaultMedias } from '../../../../hooks/useSubscriberVaultAlbums';
import { OnlyFansListIdAndName, OnlyFansSubscriberMessageUsersTtsSettings } from '../../../../types/messageUsersAutoSendWelcomeMessage';

export interface FormState {
    includeMedia: boolean;
    vaultAlbum: number;
    medias: OnlyFansVaultMedias.RestructuredResponseItem[];
    mediasPreviews: number[];
    tagCreators: boolean;
    taggedCreators: { id: number; name: string }[];
    taggedReleaseForms: { id: number; name: string }[];
    lockMessage: boolean;
    lockedText: boolean;
    usernameReplacement: string;
    excludeUserInLists: boolean;
    excludeLists: OnlyFansListIdAndName[];
    addToList: boolean;
    addToListIdAndName: OnlyFansListIdAndName | undefined | null;
    ttsSettings: OnlyFansSubscriberMessageUsersTtsSettings;
    templateText: string;
}

export const initialFormState: FormState = {
    includeMedia: false,
    vaultAlbum: -1,
    medias: [],
    mediasPreviews: [],
    tagCreators: false,
    taggedCreators: [],
    taggedReleaseForms: [],
    lockMessage: false,
    lockedText: false,
    usernameReplacement: '',
    excludeUserInLists: false,
    excludeLists: [],
    addToList: false,
    addToListIdAndName: undefined,
    ttsSettings: {
        active: false,
        message: null,
        provider: null,
        modelId: null,
        addUsername: false,
        usernameGreeting: null,
        generatedFilename: null,
        voiceSettings: null,
    },
    templateText: '',
};

type FormAction =
    | { type: 'SET_INCLUDE_MEDIA'; payload: boolean }
    | { type: 'SET_VAULT_ALBUM'; payload: number }
    | { type: 'SET_MEDIAS'; payload: OnlyFansVaultMedias.RestructuredResponseItem[] }
    | { type: 'SET_MEDIAS_PREVIEWS'; payload: number[] }
    | { type: 'SET_TAG_CREATORS'; payload: boolean }
    | { type: 'SET_TAGGED_CREATORS'; payload: { id: number; name: string }[] }
    | { type: 'SET_TAGGED_RELEASE_FORMS'; payload: { id: number; name: string }[] }
    | { type: 'SET_LOCK_MESSAGE'; payload: boolean }
    | { type: 'SET_LOCKED_TEXT'; payload: boolean }
    | { type: 'SET_USERNAME_REPLACEMENT'; payload: string }
    | { type: 'SET_EXCLUDE_USER_IN_LISTS'; payload: boolean }
    | { type: 'SET_EXCLUDE_LISTS'; payload: OnlyFansListIdAndName[] }
    | { type: 'SET_ADD_TO_LIST'; payload: boolean }
    | { type: 'SET_ADD_TO_LIST_ID_AND_NAME'; payload: OnlyFansListIdAndName | undefined | null }
    | { type: 'SET_TTS_SETTINGS'; payload: OnlyFansSubscriberMessageUsersTtsSettings }
    | { type: 'SET_TEMPLATE_TEXT'; payload: string }
    | { type: 'RESET_FORM' };

export const formReducer = (state: FormState, action: FormAction): FormState => {
    switch (action.type) {
        case 'SET_INCLUDE_MEDIA':
            return { ...state, includeMedia: action.payload };
        case 'SET_VAULT_ALBUM':
            return { ...state, vaultAlbum: action.payload };
        case 'SET_MEDIAS':
            return { ...state, medias: action.payload };
        case 'SET_MEDIAS_PREVIEWS':
            return { ...state, mediasPreviews: action.payload };
        case 'SET_TAG_CREATORS':
            return { ...state, tagCreators: action.payload };
        case 'SET_TAGGED_CREATORS':
            return { ...state, taggedCreators: action.payload };
        case 'SET_TAGGED_RELEASE_FORMS':
            return { ...state, taggedReleaseForms: action.payload };
        case 'SET_LOCK_MESSAGE':
            return { ...state, lockMessage: action.payload };
        case 'SET_LOCKED_TEXT':
            return { ...state, lockedText: action.payload };
        case 'SET_USERNAME_REPLACEMENT':
            return { ...state, usernameReplacement: action.payload };
        case 'SET_EXCLUDE_USER_IN_LISTS':
            return { ...state, excludeUserInLists: action.payload };
        case 'SET_EXCLUDE_LISTS':
            return { ...state, excludeLists: action.payload };
        case 'SET_ADD_TO_LIST':
            return { ...state, addToList: action.payload };
        case 'SET_ADD_TO_LIST_ID_AND_NAME':
            return { ...state, addToListIdAndName: action.payload };
        case 'SET_TTS_SETTINGS':
            return { ...state, ttsSettings: action.payload };
        case 'SET_TEMPLATE_TEXT':
            return { ...state, templateText: action.payload };
        case 'RESET_FORM':
            return {
                ...initialFormState,
                // Preserve settings that shouldn't be reset
                ttsSettings: state.ttsSettings,
            };
        default:
            return state;
    }
};
